export default "__VITE_ASSET__DmtjQ_uK__"